import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transformWhile(_this__u8e3s4, transform) {
  return flow(transformWhile$slambda(_this__u8e3s4, transform));
}
var AbortFlowExceptionClass;
function AbortFlowException() {
  if (AbortFlowExceptionClass === VOID) {
    class $ extends CancellationException() {
      constructor(owner) {
        return new.target.new_com_apollographql_apollo_internal_AbortFlowException_sisqlv_k$(owner);
      }
      static new_com_apollographql_apollo_internal_AbortFlowException_sisqlv_k$(owner) {
        var $this = this.new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$('Flow was aborted, no more elements needed');
        captureStack($this, $this.$throwableCtor_5);
        $this.owner_1 = owner;
        return $this;
      }
      checkOwnership_62rt9h_k$(owner) {
        if (!(this.owner_1 === owner))
          throw this;
      }
    }
    initMetadataForClass($, 'AbortFlowException');
    AbortFlowExceptionClass = $;
  }
  return AbortFlowExceptionClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var transformWhile$1$$inlined$collectWhile$1Class;
function transformWhile$1$$inlined$collectWhile$1() {
  if (transformWhile$1$$inlined$collectWhile$1Class === VOID) {
    class $_0 {
      constructor($transform, $this_flow) {
        this.$transform_1 = $transform;
        this.$this_flow_1 = $this_flow;
      }
      *emit_53hnst_k$(value, $completion) {
        if (!(yield* $(this.$transform_1(this.$this_flow_1, value, $completion), $completion))) {
          throw AbortFlowException().new_com_apollographql_apollo_internal_AbortFlowException_sisqlv_k$(this);
        }
        return Unit_instance;
      }
      emit_t92u1f_k$(value, $completion) {
        return this.emit_53hnst_k$(value, $completion);
      }
    }
    initMetadataForClass($_0, VOID, VOID, VOID, [FlowCollector()], [1]);
    transformWhile$1$$inlined$collectWhile$1Class = $_0;
  }
  return transformWhile$1$$inlined$collectWhile$1Class;
}
function transformWhile$slambda$slambda($collector) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $collector.emit_53hnst_k$(it, $completion);
    return Unit_instance;
  }), 1);
}
function transformWhile$slambda($this_transformWhile, $transform) {
  return constructCallableReference(($this$flow, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.apollographql.apollo.internal.collectWhile' call
    var this_0 = $this_transformWhile;
    var collector = new (transformWhile$1$$inlined$collectWhile$1())($transform, $this$flow);
    try {
      var tmp = transformWhile$slambda$slambda(collector);
      yield* this_0.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
    } catch ($p) {
      if ($p instanceof AbortFlowException()) {
        var e = $p;
        e.checkOwnership_62rt9h_k$(collector);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  transformWhile as transformWhile1eyv77fe96rjt,
};
//endregion

//# sourceMappingURL=flows.mjs.map
